import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { isoToJalali } from "../../../helper/isoToJalali";
import { useNavigate } from "react-router-dom";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import usePaginatedReferralList from "./usePaginatedReferralList";
import { API_BASE_URL } from "../../../config/api";

const REFERRAL_PAYOUTS_URL =
  `${API_BASE_URL}payment-payout/referrals/payouts/`;

export default function WithdrawTable() {
  const navigate = useNavigate();
  const {
    items: referalData,
    accLoading,
    isLoadingMore,
    loadMoreRef,
  } = usePaginatedReferralList({
    endpoint: REFERRAL_PAYOUTS_URL,
    navigate,
  });

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          لیست برداشت‌ها
        </h3>
      </div>

      <Table
        columns={[
          { key: "dateReq", label: "تاریخ درخواست" },
          { key: "transId", label: "کد تراکنش" },
          { key: "reqAmount", label: "مبلغ درخواستی" },
          { key: "dateDone", label: "تاریخ تکمیل" },
          {
            key: "status",
            label: "وضعیت تراکنش",
            render: (value) =>
              value === "approved" ? (
                <StatusColorful
                  SVGName="tick"
                  text="تکمیل شده"
                  className="w-24"
                  color="green"
                />
              ) : value === "pending" ? (
                <StatusColorful
                  SVGName="stall"
                  text="در انتظار"
                  className="w-24"
                  color="yellow"
                />
              ) : value === "rejected" ? (
                <StatusColorful
                  SVGName="failed"
                  text="رد شده"
                  className="w-24"
                  color="red"
                />
              ) : (
                ""
              ),
          },
        ]}
        data={
          referalData
            ? referalData?.map((referal) => ({
                dateReq: isoToJalali(referal.created_at),
                transId: referal.code,
                reqAmount: referal.total,
                status: referal.status,
                dateDone: referal?.finish_time
                  ? isoToJalali(referal.finish_time)
                  : "-",
              }))
            : []
        }
      />
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {isLoadingMore && referalData.length > 0 && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری بیشتر</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      <div ref={loadMoreRef} className="h-1 w-full" />
      {!accLoading && referalData.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
